import { createElementBlock as S, openBlock as y, createElementVNode as P, defineComponent as z, ref as T, computed as x, toRaw as C, onMounted as Q, onUnmounted as ne, watch as Z, watchEffect as ie, nextTick as j, provide as se, h as Y, Fragment as K, inject as ue, resolveComponent as D, createBlock as X, normalizeStyle as re, withCtx as B, createVNode as I, createCommentVNode as A, normalizeClass as E, toDisplayString as N, renderSlot as U, renderList as W, withModifiers as ee, Transition as de } from "vue";
import pe from "./ErrorTooltip-gIdejoEn.js";
import { r as ve, a as ce } from "./XMarkIcon-CARouk43.js";
import { t as J, o as O, H as q, N as te, u as M, K as fe, T as be, a as g } from "./dom-B5R6OWVp.js";
import { p as me, l as _, a as w, u as ye, y as he, c as ge, x as xe } from "./use-tracked-pointer-D7o8jeoa.js";
import { b as Oe } from "./use-resolve-button-type-XAZYZJQ_.js";
import { w as Le, h as Se, O as ke } from "./focus-management-uTsAyIu4.js";
import { d as we, e as Re, f as Ve, a as Te } from "./use-controllable-BEb0o1U6.js";
import { _ as Ce } from "./_plugin-vue_export-helper-CHgC5LLL.js";
function $e(e, d) {
  return y(), S("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    P("path", {
      "fill-rule": "evenodd",
      d: "M4.22 6.22a.75.75 0 0 1 1.06 0L8 8.94l2.72-2.72a.75.75 0 1 1 1.06 1.06l-3.25 3.25a.75.75 0 0 1-1.06 0L4.22 7.28a.75.75 0 0 1 0-1.06Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function De(e, d) {
  return e === d;
}
var Be = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(Be || {}), Ie = ((e) => (e[e.Single = 0] = "Single", e[e.Multi = 1] = "Multi", e))(Ie || {}), Pe = ((e) => (e[e.Pointer = 0] = "Pointer", e[e.Other = 1] = "Other", e))(Pe || {});
function Me(e) {
  requestAnimationFrame(() => requestAnimationFrame(e));
}
let oe = Symbol("ListboxContext");
function H(e) {
  let d = ue(oe, null);
  if (d === null) {
    let c = new Error(`<${e} /> is missing a parent <Listbox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(c, H), c;
  }
  return d;
}
let Ke = z({ name: "Listbox", emits: { "update:modelValue": (e) => !0 }, props: { as: { type: [Object, String], default: "template" }, disabled: { type: [Boolean], default: !1 }, by: { type: [String, Function], default: () => De }, horizontal: { type: [Boolean], default: !1 }, modelValue: { type: [Object, String, Number, Boolean], default: void 0 }, defaultValue: { type: [Object, String, Number, Boolean], default: void 0 }, form: { type: String, optional: !0 }, name: { type: String, optional: !0 }, multiple: { type: [Boolean], default: !1 } }, inheritAttrs: !1, setup(e, { slots: d, attrs: c, emit: L }) {
  let t = T(1), p = T(null), f = T(null), b = T(null), s = T([]), l = T(""), o = T(null), m = T(1);
  function h(n = (i) => i) {
    let i = o.value !== null ? s.value[o.value] : null, u = ke(n(s.value.slice()), (k) => O(k.dataRef.domRef)), v = i ? u.indexOf(i) : null;
    return v === -1 && (v = null), { options: u, activeOptionIndex: v };
  }
  let V = x(() => e.multiple ? 1 : 0), [R, $] = we(x(() => e.modelValue === void 0 ? M(V.value, { 1: [], 0: void 0 }) : e.modelValue), (n) => L("update:modelValue", n), x(() => e.defaultValue)), a = { listboxState: t, value: R, mode: V, compare(n, i) {
    if (typeof e.by == "string") {
      let u = e.by;
      return (n == null ? void 0 : n[u]) === (i == null ? void 0 : i[u]);
    }
    return e.by(n, i);
  }, orientation: x(() => e.horizontal ? "horizontal" : "vertical"), labelRef: p, buttonRef: f, optionsRef: b, disabled: x(() => e.disabled), options: s, searchQuery: l, activeOptionIndex: o, activationTrigger: m, closeListbox() {
    e.disabled || t.value !== 1 && (t.value = 1, o.value = null);
  }, openListbox() {
    e.disabled || t.value !== 0 && (t.value = 0);
  }, goToOption(n, i, u) {
    if (e.disabled || t.value === 1) return;
    let v = h(), k = xe(n === w.Specific ? { focus: w.Specific, id: i } : { focus: n }, { resolveItems: () => v.options, resolveActiveIndex: () => v.activeOptionIndex, resolveId: (F) => F.id, resolveDisabled: (F) => F.dataRef.disabled });
    l.value = "", o.value = k, m.value = u ?? 1, s.value = v.options;
  }, search(n) {
    if (e.disabled || t.value === 1) return;
    let i = l.value !== "" ? 0 : 1;
    l.value += n.toLowerCase();
    let u = (o.value !== null ? s.value.slice(o.value + i).concat(s.value.slice(0, o.value + i)) : s.value).find((k) => k.dataRef.textValue.startsWith(l.value) && !k.dataRef.disabled), v = u ? s.value.indexOf(u) : -1;
    v === -1 || v === o.value || (o.value = v, m.value = 1);
  }, clearSearch() {
    e.disabled || t.value !== 1 && l.value !== "" && (l.value = "");
  }, registerOption(n, i) {
    let u = h((v) => [...v, { id: n, dataRef: i }]);
    s.value = u.options, o.value = u.activeOptionIndex;
  }, unregisterOption(n) {
    let i = h((u) => {
      let v = u.findIndex((k) => k.id === n);
      return v !== -1 && u.splice(v, 1), u;
    });
    s.value = i.options, o.value = i.activeOptionIndex, m.value = 1;
  }, select(n) {
    e.disabled || $(M(V.value, { 0: () => n, 1: () => {
      let i = C(a.value.value).slice(), u = C(n), v = i.findIndex((k) => a.compare(u, C(k)));
      return v === -1 ? i.push(u) : i.splice(v, 1), i;
    } }));
  } };
  he([f, b], (n, i) => {
    var u;
    a.closeListbox(), Le(i, Se.Loose) || (n.preventDefault(), (u = O(f)) == null || u.focus());
  }, x(() => t.value === 0)), se(oe, a), ge(x(() => M(t.value, { 0: _.Open, 1: _.Closed })));
  let r = x(() => {
    var n;
    return (n = O(f)) == null ? void 0 : n.closest("form");
  });
  return Q(() => {
    Z([r], () => {
      if (!r.value || e.defaultValue === void 0) return;
      function n() {
        a.select(e.defaultValue);
      }
      return r.value.addEventListener("reset", n), () => {
        var i;
        (i = r.value) == null || i.removeEventListener("reset", n);
      };
    }, { immediate: !0 });
  }), () => {
    let { name: n, modelValue: i, disabled: u, form: v, ...k } = e, F = { open: t.value === 0, disabled: u, value: R.value };
    return Y(K, [...n != null && R.value != null ? Re({ [n]: R.value }).map(([G, ae]) => Y(Ve, fe({ features: Te.Hidden, key: G, as: "input", type: "hidden", hidden: !0, readOnly: !0, form: v, name: G, value: ae }))) : [], q({ ourProps: {}, theirProps: { ...c, ...be(k, ["defaultValue", "onUpdate:modelValue", "horizontal", "multiple", "by"]) }, slot: F, slots: d, attrs: c, name: "Listbox" })]);
  };
} }), je = z({ name: "ListboxLabel", props: { as: { type: [Object, String], default: "label" }, id: { type: String, default: () => `headlessui-listbox-label-${J()}` } }, setup(e, { attrs: d, slots: c }) {
  let L = H("ListboxLabel");
  function t() {
    var p;
    (p = O(L.buttonRef)) == null || p.focus({ preventScroll: !0 });
  }
  return () => {
    let p = { open: L.listboxState.value === 0, disabled: L.disabled.value }, { id: f, ...b } = e, s = { id: f, ref: L.labelRef, onClick: t };
    return q({ ourProps: s, theirProps: b, slot: p, attrs: d, slots: c, name: "ListboxLabel" });
  };
} }), Ae = z({ name: "ListboxButton", props: { as: { type: [Object, String], default: "button" }, id: { type: String, default: () => `headlessui-listbox-button-${J()}` } }, setup(e, { attrs: d, slots: c, expose: L }) {
  let t = H("ListboxButton");
  L({ el: t.buttonRef, $el: t.buttonRef });
  function p(l) {
    switch (l.key) {
      case g.Space:
      case g.Enter:
      case g.ArrowDown:
        l.preventDefault(), t.openListbox(), j(() => {
          var o;
          (o = O(t.optionsRef)) == null || o.focus({ preventScroll: !0 }), t.value.value || t.goToOption(w.First);
        });
        break;
      case g.ArrowUp:
        l.preventDefault(), t.openListbox(), j(() => {
          var o;
          (o = O(t.optionsRef)) == null || o.focus({ preventScroll: !0 }), t.value.value || t.goToOption(w.Last);
        });
        break;
    }
  }
  function f(l) {
    switch (l.key) {
      case g.Space:
        l.preventDefault();
        break;
    }
  }
  function b(l) {
    t.disabled.value || (t.listboxState.value === 0 ? (t.closeListbox(), j(() => {
      var o;
      return (o = O(t.buttonRef)) == null ? void 0 : o.focus({ preventScroll: !0 });
    })) : (l.preventDefault(), t.openListbox(), Me(() => {
      var o;
      return (o = O(t.optionsRef)) == null ? void 0 : o.focus({ preventScroll: !0 });
    })));
  }
  let s = Oe(x(() => ({ as: e.as, type: d.type })), t.buttonRef);
  return () => {
    var l, o;
    let m = { open: t.listboxState.value === 0, disabled: t.disabled.value, value: t.value.value }, { id: h, ...V } = e, R = { ref: t.buttonRef, id: h, type: s.value, "aria-haspopup": "listbox", "aria-controls": (l = O(t.optionsRef)) == null ? void 0 : l.id, "aria-expanded": t.disabled.value ? void 0 : t.listboxState.value === 0, "aria-labelledby": t.labelRef.value ? [(o = O(t.labelRef)) == null ? void 0 : o.id, h].join(" ") : void 0, disabled: t.disabled.value === !0 ? !0 : void 0, onKeydown: p, onKeyup: f, onClick: b };
    return q({ ourProps: R, theirProps: V, slot: m, attrs: d, slots: c, name: "ListboxButton" });
  };
} }), Ee = z({ name: "ListboxOptions", props: { as: { type: [Object, String], default: "ul" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, id: { type: String, default: () => `headlessui-listbox-options-${J()}` } }, setup(e, { attrs: d, slots: c, expose: L }) {
  let t = H("ListboxOptions"), p = T(null);
  L({ el: t.optionsRef, $el: t.optionsRef });
  function f(l) {
    switch (p.value && clearTimeout(p.value), l.key) {
      case g.Space:
        if (t.searchQuery.value !== "") return l.preventDefault(), l.stopPropagation(), t.search(l.key);
      case g.Enter:
        if (l.preventDefault(), l.stopPropagation(), t.activeOptionIndex.value !== null) {
          let o = t.options.value[t.activeOptionIndex.value];
          t.select(o.dataRef.value);
        }
        t.mode.value === 0 && (t.closeListbox(), j(() => {
          var o;
          return (o = O(t.buttonRef)) == null ? void 0 : o.focus({ preventScroll: !0 });
        }));
        break;
      case M(t.orientation.value, { vertical: g.ArrowDown, horizontal: g.ArrowRight }):
        return l.preventDefault(), l.stopPropagation(), t.goToOption(w.Next);
      case M(t.orientation.value, { vertical: g.ArrowUp, horizontal: g.ArrowLeft }):
        return l.preventDefault(), l.stopPropagation(), t.goToOption(w.Previous);
      case g.Home:
      case g.PageUp:
        return l.preventDefault(), l.stopPropagation(), t.goToOption(w.First);
      case g.End:
      case g.PageDown:
        return l.preventDefault(), l.stopPropagation(), t.goToOption(w.Last);
      case g.Escape:
        l.preventDefault(), l.stopPropagation(), t.closeListbox(), j(() => {
          var o;
          return (o = O(t.buttonRef)) == null ? void 0 : o.focus({ preventScroll: !0 });
        });
        break;
      case g.Tab:
        l.preventDefault(), l.stopPropagation();
        break;
      default:
        l.key.length === 1 && (t.search(l.key), p.value = setTimeout(() => t.clearSearch(), 350));
        break;
    }
  }
  let b = me(), s = x(() => b !== null ? (b.value & _.Open) === _.Open : t.listboxState.value === 0);
  return () => {
    var l, o, m, h;
    let V = { open: t.listboxState.value === 0 }, { id: R, ...$ } = e, a = { "aria-activedescendant": t.activeOptionIndex.value === null || (l = t.options.value[t.activeOptionIndex.value]) == null ? void 0 : l.id, "aria-multiselectable": t.mode.value === 1 ? !0 : void 0, "aria-labelledby": (h = (o = O(t.labelRef)) == null ? void 0 : o.id) != null ? h : (m = O(t.buttonRef)) == null ? void 0 : m.id, "aria-orientation": t.orientation.value, id: R, onKeydown: f, role: "listbox", tabIndex: 0, ref: t.optionsRef };
    return q({ ourProps: a, theirProps: $, slot: V, attrs: d, slots: c, features: te.RenderStrategy | te.Static, visible: s.value, name: "ListboxOptions" });
  };
} }), ze = z({ name: "ListboxOption", props: { as: { type: [Object, String], default: "li" }, value: { type: [Object, String, Number, Boolean] }, disabled: { type: Boolean, default: !1 }, id: { type: String, default: () => `headlessui-listbox.option-${J()}` } }, setup(e, { slots: d, attrs: c, expose: L }) {
  let t = H("ListboxOption"), p = T(null);
  L({ el: p, $el: p });
  let f = x(() => t.activeOptionIndex.value !== null ? t.options.value[t.activeOptionIndex.value].id === e.id : !1), b = x(() => M(t.mode.value, { 0: () => t.compare(C(t.value.value), C(e.value)), 1: () => C(t.value.value).some((a) => t.compare(C(a), C(e.value))) })), s = x(() => M(t.mode.value, { 1: () => {
    var a;
    let r = C(t.value.value);
    return ((a = t.options.value.find((n) => r.some((i) => t.compare(C(i), C(n.dataRef.value))))) == null ? void 0 : a.id) === e.id;
  }, 0: () => b.value })), l = x(() => ({ disabled: e.disabled, value: e.value, textValue: "", domRef: p }));
  Q(() => {
    var a, r;
    let n = (r = (a = O(p)) == null ? void 0 : a.textContent) == null ? void 0 : r.toLowerCase().trim();
    n !== void 0 && (l.value.textValue = n);
  }), Q(() => t.registerOption(e.id, l)), ne(() => t.unregisterOption(e.id)), Q(() => {
    Z([t.listboxState, b], () => {
      t.listboxState.value === 0 && b.value && M(t.mode.value, { 1: () => {
        s.value && t.goToOption(w.Specific, e.id);
      }, 0: () => {
        t.goToOption(w.Specific, e.id);
      } });
    }, { immediate: !0 });
  }), ie(() => {
    t.listboxState.value === 0 && f.value && t.activationTrigger.value !== 0 && j(() => {
      var a, r;
      return (r = (a = O(p)) == null ? void 0 : a.scrollIntoView) == null ? void 0 : r.call(a, { block: "nearest" });
    });
  });
  function o(a) {
    if (e.disabled) return a.preventDefault();
    t.select(e.value), t.mode.value === 0 && (t.closeListbox(), j(() => {
      var r;
      return (r = O(t.buttonRef)) == null ? void 0 : r.focus({ preventScroll: !0 });
    }));
  }
  function m() {
    if (e.disabled) return t.goToOption(w.Nothing);
    t.goToOption(w.Specific, e.id);
  }
  let h = ye();
  function V(a) {
    h.update(a);
  }
  function R(a) {
    h.wasMoved(a) && (e.disabled || f.value || t.goToOption(w.Specific, e.id, 0));
  }
  function $(a) {
    h.wasMoved(a) && (e.disabled || f.value && t.goToOption(w.Nothing));
  }
  return () => {
    let { disabled: a } = e, r = { active: f.value, selected: b.value, disabled: a }, { id: n, value: i, disabled: u, ...v } = e, k = { id: n, ref: p, role: "option", tabIndex: a === !0 ? void 0 : -1, "aria-disabled": a === !0 ? !0 : void 0, "aria-selected": b.value, disabled: void 0, onClick: o, onFocus: m, onPointerenter: V, onMouseenter: V, onPointermove: R, onMousemove: R, onPointerleave: $, onMouseleave: $ };
    return q({ ourProps: k, theirProps: v, slot: r, attrs: c, slots: d, name: "ListboxOption" });
  };
} });
const Fe = z({
  components: {
    ErrorTooltip: pe,
    Listbox: Ke,
    ListboxButton: Ae,
    ListboxLabel: je,
    ListboxOption: ze,
    ListboxOptions: Ee,
    ChevronDownIcon: $e,
    XMarkIcon: ce,
    CheckIcon: ve
  },
  props: {
    modelValue: [Object, String, Boolean, Array, Number, Function],
    options: [Array, Function],
    /** transform value */
    optionsValue: {
      type: Function,
      default: (e) => e
    },
    /** String attribut or Function to display options */
    optionsLabel: [String, Function],
    /**
     * String attribut or Function to compare options and identify current value
     * rem: apply on value = return of `optionsValue`
     */
    optionsKey: {
      type: [String, Function]
    },
    optionsKeyDisabled: { type: Array },
    multiple: Boolean,
    placeholder: String,
    disabled: Boolean,
    nullable: Boolean,
    nullableValue: [Number, Object],
    // any
    nullableUndefined: Boolean,
    selectClass: String,
    dropdownClass: String,
    inline: Boolean,
    validation: Object
  },
  emits: ["update:model-value", "change"],
  slots: Object,
  setup(e, { emit: d }) {
    function c(l) {
      return typeof e.optionsKey == "string" ? le(l == null ? void 0 : l[e.optionsKey]) : le(e.optionsKey ? e.optionsKey(l) : l, e.placeholder);
    }
    function L(l) {
      return e.optionsLabel ? typeof e.optionsLabel == "string" ? l !== null && typeof l == "object" ? `${l[e.optionsLabel]}` : `${l}` : e.optionsLabel(l) : `${l}`;
    }
    const t = T([]), p = T([]);
    Z(() => e.options, async (l) => {
      t.value = typeof l == "function" ? await l() : l || [], p.value = t.value.map((o) => c(e.optionsValue(o)));
    }, { immediate: !0 });
    function f(l) {
      var o;
      e.multiple ? l = (o = l == null ? void 0 : l.map((m) => e.optionsValue(m))) == null ? void 0 : o.filter((m) => m !== void 0) : l = e.optionsValue(l), d("update:model-value", l), d("change", l);
    }
    function b() {
      if (e.multiple) {
        const l = (e.modelValue || []).map(c);
        return p.value.reduce((o, m, h) => (l.indexOf(m) !== -1 && o.push(t.value[h]), o), []);
      } else {
        const l = p.value.indexOf(c(e.modelValue));
        return l !== -1 ? t.value[l] : e.modelValue;
      }
    }
    const s = x({
      get() {
        return b();
      },
      set(l) {
        f(l);
      }
    });
    return {
      model: s,
      opts: t,
      optsKey: p,
      optToLabel: L,
      compare(l, o) {
        return (l && c(e.optionsValue(l))) === (o && c(e.optionsValue(o)));
      },
      noValue: x(
        () => e.multiple ? s.value.length === 0 : !s.value
      ),
      clazz: x(() => {
        const l = ["tx-select-b"];
        return e.disabled && l.push("tx-select-b-disabled"), e.selectClass && l.push(e.selectClass), l;
      }),
      remove(l) {
        s.value.splice(l, 1), f(s.value);
      },
      nullify() {
        e.nullableValue !== void 0 ? s.value = e.nullableValue : e.nullableUndefined === !0 ? s.value = void 0 : e.multiple ? s.value = [] : s.value = void 0;
      }
    };
  }
});
function le(e, d) {
  return e !== null && typeof e == "object" ? JSON.stringify(e) : `${e}`;
}
const Ne = { key: 0 }, Ue = {
  key: 1,
  class: "tw-input-label-wildcard"
}, qe = {
  key: 1,
  class: "tx-select-button-novalue"
}, He = {
  key: 0,
  class: "tx-select-button-slot-multi"
}, Xe = {
  key: 0,
  class: "tx-select-button"
}, Qe = { class: "tx-select-button-multi-label" }, _e = ["onClick"], Je = { class: "tx-select-chevron" }, We = { class: "tx-select-option-label" }, Ze = {
  key: 0,
  class: "tx-select-option-check"
}, Ge = { class: "select-none" };
function Ye(e, d, c, L, t, p) {
  const f = D("ListboxLabel"), b = D("XMarkIcon"), s = D("ChevronDownIcon"), l = D("ListboxButton"), o = D("CheckIcon"), m = D("ListboxOption"), h = D("ListboxOptions"), V = D("Listbox"), R = D("ErrorTooltip");
  return y(), X(R, {
    class: "tx-select",
    style: re(e.$attrs.style),
    validation: e.validation
  }, {
    default: B(() => [
      I(V, {
        as: "div",
        modelValue: e.model,
        "onUpdate:modelValue": d[1] || (d[1] = ($) => e.model = $),
        disabled: e.disabled,
        multiple: e.multiple,
        by: e.compare
      }, {
        default: B(({ open: $ }) => [
          P("div", null, [
            !e.noValue || e.validation && e.validation.required ? (y(), X(f, {
              key: 0,
              class: E(["tw-input-label", { "t-input-hide-label": !e.$props.placeholder }])
            }, {
              default: B(() => [
                e.noValue ? A("", !0) : (y(), S("span", Ne, N(e.$props.placeholder || ""), 1)),
                e.validation && e.validation.required ? (y(), S("span", Ue, " ∗ ")) : A("", !0)
              ]),
              _: 1
            }, 8, ["class"])) : A("", !0),
            I(l, {
              class: E(e.clazz)
            }, {
              default: B(() => [
                "inputs" in e.$slots ? U(e.$slots, "inputs", {
                  key: 0,
                  value: e.model
                }) : e.noValue ? (y(), S("span", qe, N(e.$props.placeholder || " "), 1)) : "input" in e.$slots ? (y(), S(K, { key: 2 }, [
                  e.multiple ? (y(), S("div", He, [
                    (y(!0), S(K, null, W(e.model, (a, r) => U(e.$slots, "input", {
                      key: r,
                      value: a,
                      remove: () => e.remove(r)
                    })), 128))
                  ])) : U(e.$slots, "input", {
                    key: 1,
                    value: e.model
                  })
                ], 64)) : (y(), S(K, { key: 3 }, [
                  e.multiple ? (y(!0), S(K, { key: 1 }, W(e.model, (a, r) => (y(), S("div", {
                    key: r,
                    class: "tx-select-button-multi"
                  }, [
                    P("span", Qe, N(e.optToLabel(a)), 1),
                    P("span", {
                      class: "tx-select-button-multi-remove",
                      onClick: ee((n) => e.remove(r), ["stop"])
                    }, [
                      I(b)
                    ], 8, _e)
                  ]))), 128)) : (y(), S("span", Xe, N(e.optToLabel(e.model)) + " ", 1))
                ], 64)),
                P("span", Je, [
                  I(s, {
                    "aria-hidden": "true",
                    class: E(["ease-in-out tt-duration-200", { "tt-rotate-180": $ }])
                  }, null, 8, ["class"])
                ]),
                e.$props.nullable && !e.noValue ? (y(), S("button", {
                  key: 4,
                  class: "tx-select-nullable",
                  onClick: d[0] || (d[0] = ee((...a) => e.nullify && e.nullify(...a), ["prevent"]))
                }, [
                  I(b, { "aria-hidden": "true" })
                ])) : A("", !0)
              ]),
              _: 2
            }, 1032, ["class"]),
            I(de, { name: "transition-opacity" }, {
              default: B(() => [
                I(h, {
                  class: E(["tx-select-options", [{ "tx-select-options-inline": e.inline }, e.$props.dropdownClass]])
                }, {
                  default: B(() => [
                    (y(!0), S(K, null, W(e.opts, (a, r) => (y(), X(m, {
                      as: "template",
                      key: e.optsKey[r],
                      value: a,
                      class: E({ "tt-opacity-80": e.$props.optionsKeyDisabled && e.$props.optionsKeyDisabled.indexOf(e.optsKey[r]) !== -1 }),
                      disabled: e.$props.optionsKeyDisabled && e.$props.optionsKeyDisabled.indexOf(e.optsKey[r]) !== -1
                    }, {
                      default: B(({ active: n, selected: i, disabled: u }) => [
                        P("li", {
                          class: E([
                            n ? "tx-select-option-active" : "tx-select-option-not-active",
                            i ? "tx-select-option-selected" : "tx-select-option-not-selected",
                            "default" in e.$slots ? "tx-select-option-slot" : "tx-select-option-not-slot",
                            "tx-select-option"
                          ])
                        }, [
                          e.$slots.default ? U(e.$slots, "default", {
                            key: 1,
                            opt: a,
                            selected: i,
                            active: n,
                            disabled: u
                          }) : (y(), S(K, { key: 0 }, [
                            P("span", We, N(e.optToLabel(a)), 1),
                            i ? (y(), S("span", Ze, [
                              I(o, { "aria-hidden": "true" })
                            ])) : A("", !0)
                          ], 64))
                        ], 2)
                      ]),
                      _: 2
                    }, 1032, ["value", "class", "disabled"]))), 128)),
                    "end" in e.$slots ? (y(), X(m, {
                      as: "template",
                      key: "slotend"
                    }, {
                      default: B(({ active: a }) => [
                        P("li", Ge, [
                          U(e.$slots, "end", { active: a })
                        ])
                      ]),
                      _: 3
                    })) : A("", !0)
                  ]),
                  _: 3
                }, 8, ["class"])
              ]),
              _: 3
            })
          ])
        ]),
        _: 3
      }, 8, ["modelValue", "disabled", "multiple", "by"])
    ]),
    _: 3
  }, 8, ["style", "validation"]);
}
const rt = /* @__PURE__ */ Ce(Fe, [["render", Ye]]);
export {
  rt as default
};
//# sourceMappingURL=Select-Dmjule_0.js.map
